;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import StackSpaced from "../../../../pages/loginAndSignUp/shared/StackSpaced"
import ColorButton from "../../../../pages/loginAndSignUp/shared/ColorButton"
import TextField from "@mui/material/TextField"
import SecondaryLinkContainer from "../../../../pages/loginAndSignUp/shared/SecondaryLinkContainer"
import updateErrorMessage from "../../../../../graphql/mutations/snackbarMessage/updateErrorMessage"
import validateEmail from "../../../../../lib/validate/validateEmail"
import validatePassword, {
  getPasswordErrorMessage,
} from "../../../../../lib/validate/validatePassword"

const EMAIL = "Email"
const PASSWORD = "Password"

export default function CreateAccount({
  onSignUpPage,
  email,
  setEmail,
  password,
  setPassword,
  visible,
  onCreateAccountContinue,
  onLoginHref,
}) {
  const handleEmailChange = (event) => {
    setEmail(event.target.value)
  }

  const handlePasswordChange = (event) => {
    setPassword(event.target.value)
  }

  const isInvalid = (label, getMessage) => {
    let userAnswer = label == EMAIL ? email : password

    // if email, make sure it is valid

    if (!userAnswer) {
      return false
    }

    if (label.toLowerCase().includes("email") && !validateEmail(userAnswer)) {
      if (getMessage) {
        return "Enter a valid email"
      }
      return true
    }

    if (label.toLowerCase().includes("password") && !validatePassword(userAnswer)) {
      // test if any white space in string
      if (/^.*\s+.*$/.test(userAnswer)) {
        return "Password cannot contain any white space."
      }
      if (getMessage) {
        return "Password must be at least 8 characters long and contain the following: a number, an uppercase letter, a lowercase letter, and a special character."
      }
      return true
    }

    return false
  }

  const getType = (label) => {
    if (label.toLowerCase().includes("email")) {
      return "email"
    } else if (label.toLowerCase().includes("password")) {
      return "password"
    } else {
      return null
    }
  }

  const handleContinueClick = async () => {
    if (!email || !validateEmail(email)) {
      updateErrorMessage("Enter a valid email")
      return
    }

    if (!password) {
      updateErrorMessage("Password is required")
      return
    }

    const passwordError = getPasswordErrorMessage(password)
    if (passwordError) {
      updateErrorMessage(passwordError)
      return
    }

    onCreateAccountContinue()
  }

  const renderContinueButton = () => {
    return (
      <div
        className={"mt-[20px] w-full flex justify-center"}
        key={"continue-button"}
      >
        <ColorButton
          onClick={handleContinueClick}
          variant="contained"
          color="primary"
        >
          Continue
        </ColorButton>
      </div>
    )
  }

  const renderEmailAndPassword = () => {
    return [
      <StackSpaced spacing={2} key={"stacks-ct-act"}>
        <TextField
          variant="outlined"
          fullWidth={true}
          label={EMAIL}
          type={getType(EMAIL)}
          value={email}
          error={!!isInvalid(EMAIL, false)}
          helperText={isInvalid(EMAIL, true)}
          onChange={(event) => handleEmailChange(event)}
          sx={{ maxWidth: "308px" }}
          autoFocus
        />
        <TextField
          variant="outlined"
          fullWidth={true}
          label={PASSWORD}
          type={getType(PASSWORD)}
          value={password}
          error={!!isInvalid(PASSWORD, false)}
          helperText={isInvalid(PASSWORD, true)}
          onChange={(event) => handlePasswordChange(event)}
          sx={{ maxWidth: "308px" }}
        />
      </StackSpaced>,
      renderContinueButton(),
      <div className={"mt-[20px]"} key={"already-got-one"}>
        Already have an account?{" "}
        <SecondaryLinkContainer text={"Log in"} href={onLoginHref} />
      </div>,
    ]
  }

  return (
    <div
      className={
        visible
          ? "flex flex-col items-center justify-center w-full max-w-[500px] text-black"
          : "hidden"
      }
    >
      {/* <div className={``}>
        <SignUpLoginHeader text={onSignUpPage ? EMAIL_PAGE_TITLE : "Sign up"} />
      </div> */}

      {renderEmailAndPassword()}
    </div>
  )
}
